<div class="row">
  <mat-form-field label="Search term" class="col-12" appearance="outline" floatLabel="always">
    <input placeholder="Search term" matInput [(ngModel)]="searchTerm" (blur)="searchGrowers()" (keydown.enter)="searchGrowers()" />

    <div matSuffix>
      <button
        class="d-inline-block"
        (click)="searchGrowers()"
        mat-icon-button
        color="primary" matSuffix>
        <mat-icon>search</mat-icon>
      </button>

      <button
        *ngIf="searchTerm"
        class="d-inline-block"
        (click)="searchTerm = ''; searchGrowers()"
        mat-icon-button
        color="warn" matSuffix>
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </mat-form-field>
</div>

<ng-container *ngIf="searchTerm && (searchResults || isSearching)">
  <mat-divider></mat-divider>

  <ng-container *ngIf="isSearching">
    <mat-spinner
      diameter="40"
      class="ml-auto mr-auto d-block mt-50 mb-25" color="primary"></mat-spinner>
    <br/>
  </ng-container>

  <!-- Fake Mat Table for Styling -->
  <mat-table style="display: none; visibility: hidden;">
    <mat-header-row *matHeaderRowDef="[]"></mat-header-row>
  </mat-table>

  <div *ngIf="!isSearching" style="overflow-x: scroll;">

    <table mat-table [dataSource]="dataSource" matSort matSortDisableClear class="mat-table w-100" style="max-width: 100%;" *ngIf="searchResults.length > 0">
      <!-- Column -->
      <ng-container matColumnDef="id">
        <th fxFlex="10%" mat-header-cell *matHeaderCellDef mat-sort-header> Prop Id </th>
        <td fxFlex="10%" mat-cell *matCellDef="let element" class="ellipsis clickable" (click)="selectProperty(element)"> {{element.id}} </td>
      </ng-container>

      <!-- Column -->
      <ng-container matColumnDef="growerDescription">
        <th fxFlex="35%" mat-header-cell *matHeaderCellDef mat-sort-header> Grower </th>
        <td fxFlex="35%" mat-cell *matCellDef="let element" class="ellipsis clickable" (click)="selectProperty(element)"> {{element.growerDescription}} </td>
      </ng-container>

      <!-- Column
      <ng-container matColumnDef="property">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Property </th>
        <td mat-cell *matCellDef="let element" class="ellipsis"> {{}} </td>
      </ng-container>-->

      <!-- Column -->
      <ng-container matColumnDef="nameAddress">
        <th fxFlex="50%" mat-header-cell *matHeaderCellDef mat-sort-header> Address </th>
        <td fxFlex="50%" mat-cell *matCellDef="let element" class="ellipsis clickable" (click)="selectProperty(element)"> {{ element.nameAddress }} </td>
      </ng-container>

      <!-- Column -->
      <ng-container matColumnDef="selected">
        <th fxFlex="5%" mat-header-cell *matHeaderCellDef mat-sort-header> </th>
        <td fxFlex="5%" mat-cell *matCellDef="let element" class="clickable" (click)="selectProperty(element)"><mat-icon style="color: green; vertical-align: middle;" *ngIf="isHighlighted(element)">check</mat-icon></td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'selected': isHighlighted(row) }"></tr>
    </table>

    <mat-paginator *ngIf="searchResults.length > 0" [pageSizeOptions]="[20, 50, 100]" showFirstLastButtons></mat-paginator>

    <div *ngIf="searchTerm && searchResults && searchResults.length === 0" class="text-center mt-20 mb-20">
      <mat-icon style="width: 50px; height: 50px; font-size: 50px;">search</mat-icon><br/>
      <h2>Nothing found for search term..</h2>
    </div>

  </div>

</ng-container>


<!-- Menu
<mat-menu #growerMenu="matMenu" [overlapTrigger]="false">
  <ng-template matMenuContent let-property="property">
    <button mat-menu-item (click)="userProfile(property)">
      <mat-icon>open_in_browser</mat-icon>
      <span>Profile</span>
    </button>
    <button mat-menu-item>
      <mat-icon>open_in_browser</mat-icon>
      <span></span>
    </button>
    <button mat-menu-item>
      <mat-icon>open_in_browser</mat-icon>
      <span></span>
    </button>
    <button mat-menu-item>
      <mat-icon>open_in_browser</mat-icon>
      <span></span>
    </button>
    <button mat-menu-item>
      <mat-icon>open_in_browser</mat-icon>
      <span></span>
    </button>
  </ng-template>
</mat-menu>
-->

